import * as firebase from 'firebase/app';
import 'firebase/auth';

import { Config } from '@/config';

if (!firebase.apps.length) {
  firebase.initializeApp(Config.FirebaseConfig);
}

export const firebaseAuth = firebase.auth();
